export default __webpack_public_path__ + "static/media/qrcode_apple.0ae322db.png";